// extracted by mini-css-extract-plugin
export default {"editorContainer":"RichTextEditor_editorContainer__b5EpU","toolbar":"RichTextEditor_toolbar__17EwJ","dark":"RichTextEditor_dark__ABzhX"};